<template lang="html">
  <div class="search-image-preview-modal artwork-overlay">
    <div class="artwork-overlay__content" v-if="currentImage">
      <div class="artwork-overlay__header">
        <div class="artwork-overlay__author">
          <h2>
            <a :href="`/illustrator/${currentImage._source.illustrator.user.name}/portfolio`">
              {{ getIllustratorName() }}
            </a>
          </h2>
          <span v-if="currentImage._source.agencyUrl">Represented by
                        <a :href="currentImage._source.agencyUrl">
                           {{ currentImage._source.agencyName }}
                        </a>
                    </span>
        </div>
        <div class="artwork-overlay__buttons">
          <a :href="`/illustrator/${currentImage._source.illustrator.user.name}/portfolio`"
             title="View Artist Portfolio" class="btn btn--stroke artwork-overlay__btn">View Portfolio</a>
        </div>
        <div class="artwork-overlay__nav">
          <a href="#0" class="ci-previous-link" v-if="prevImage" @click.prevent="openNewImage(prevImage._id)">Prev</a>
          <a href="#0" class="ci-next-link" v-if="nextImage" @click.prevent="openNewImage(nextImage._id)">Next</a>
        </div>
      </div>
      <div class="artwork-overlay__media media-wrap">
        <div class="media-item ci-width-full text-center">
          <a :href="currentImage._source.publicPath" class="text-center">
            <img :src="currentImage._source.esFullImage" sizes="(max-width: 2000px) 100vw, 2000px" alt="" data-rjs="2">
            <span class="artwork-overlay__title" v-html="currentImage._source.title"></span>
          </a>
        </div>
      </div>
    </div> <!-- end artwork-overlay__content -->

    <a href="#0" class="artwork-overlay__close" title="close" @click="closeModal">Close</a>
  </div>
</template>

<script>
// Component to show full images from search results

import _ from 'lodash';

export default {
  props: ['currentImage', 'prevImage', 'nextImage'],
  methods: {
    openNewImage: function (imageId) {
      this.$emit('changeImage', imageId);
    },
    getIllustratorName: function () {
      let fName = _.get(this.currentImage, '_source.illustrator.first_name');
      let lName = _.get(this.currentImage, '_source.illustrator.last_name');

      if (fName && lName) {
        return fName + ' ' + lName;
      } else {
        return _.get(this.currentImage, '_source.username');
      }

    },
    closeModal: function () {
      this.$emit('closeModal');
    }
  },
};
</script>